export default [
  {
    value: 'Main',
    text: 'Principal',
  },
  {
    value: 'Tax',
    text: 'Taxa',
  },
  {
    value: 'Commission',
    text: 'Comissão',
  },
];
